<template>

    <v-modal
        :open="open"
        inner-class="c-modal_history">
        <button
            class="c-modal_history__close"
            type="button"
            @click="close">
        </button>
        <h3 class="c-modal_history__title">{{ title }}</h3>
        <ul class="c-modal_history__list">
            <slot></slot>
            <li v-if="noHistory" class="c-modal_history__empty">Brak historii zmian</li>
        </ul>

        <v-loader :loading="isFetching"></v-loader>
    </v-modal>

</template>


<script>

import {mapGetters} from 'vuex'
import VLoader from 'Components/VLoader'
import VModal from 'Components/VModal'

export default {

    name: 'VisitHistoryModal',

    props: {
        title: String
    },

    data() {
        return {
            noHistory: false,
            isFetching: null,
            open: false
        }
    },

    computed: {
        ...mapGetters(['fieldHistory'])
    },

    methods: {
        close() {
            this.open = false
            this.$emit('close')
        }
    },

    mounted() {
        this.$on('open', (fieldName) => {
            this.open = true
            this.isFetching = true
            this.$store.dispatch('VISIT_FIELD_HISTORY_FETCH', fieldName).then(({data}) => {
                this.isFetching = false
                this.noHistory = (data.data.length === 0)
                this.$emit('fetched', data.data)
            }).catch((error) => {
                this.isFetching = false
                this.open = false
                this.$alert.error('Pobieranie historii', error.response.data.message)
            })
        })
    },

    beforeDestroy() {
        this.$off('open')
    },

    components: {
        VModal,
        VLoader
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-modal_history {
    position: relative;
    max-width: 800px !important;
    max-height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;

    &__title {
        text-align: center;
    }
    &__close {
        cursor: pointer;
        background-color: transparent;
        border: none;
        outline: 0 !important;
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        background-image: url('#{$icons}/delete1.svg');
        background-position: center;
        background-repeat: no-repeat;
        background-size: 1rem 1rem;
    }
    &__empty {
        font-size: 1.2rem;
        color: $c-secondary;
        text-align: center;
        width: 100%;
        margin: 100px 0;
    }
    &__list {
        height: 100%;
        overflow-y: auto;
        overflow-x: hidden;
    }
}

</style>
